import { rejectSubmission } from '../../../../services/popupApi';
import { rejectionReasons } from './config';

export const api = {
  submit: async (values, context) => {
    const reason = rejectionReasons.find((r) => r.id === values.rejectReason);
    await rejectSubmission({
      submissionId: context.selectedIds[0],
      rejectReasonId: values.rejectReason,
      rejectReason: reason?.name ?? '',
      rejectReasonComments: values.rejectReasonComments,
    });
  },
};
